export default "__VITE_ASSET__4Ek7XBI2__"